export default __webpack_public_path__ + "static/media/ordinacija.38bccde0.jpg";